<template>
  <div>
    <common-header></common-header>
    <div class="product-detail">
      <productHead></productHead>
      <div class="productInformation">
        <div class="content">
          <p @click="goProduct" class="title">{{lanInfo.banner01.title}} > <span>{{lanInfo.newsDetailTitle}}</span></p>
          <div class="contmag">
            <div class="headcont">
<!--              <h2>ddd</h2>-->
              <h2>{{ this.title }}</h2>
              <p>{{lanInfo.updated}}：{{ this.createDates }}</p>
            </div>
            <div class="contents" v-html="this.content"></div>
            <div class="footcont">
              <div class="lastArticle">
                <span v-if="this.lastPage == undefined"></span>
                <span v-else @click='clickpage(lastPage.id)'>&lt; {{lanInfo.paging.previous}}：<b>{{ this.lastPage.title }}</b></span>
              </div>
              <div class="nextArticle" style="text-align: right;">
                <span v-if="this.nextPage == undefined"></span>
                <span v-else @click='clickpage(nextPage.id)'><b>{{lanInfo.paging.next}}：{{ this.nextPage.title }}</b>&nbsp;&nbsp;&gt;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productHead from './Producthead'

export default {
  name: 'ProductDetails',
  data() {
    return {
      querys: {},
      content: '',
      title: '',
      nextPage: {},
      lastPage: {},
      createDates: ''
    }
  },
  components: {
    productHead
  },
  mounted() {
    this.querys = this.$queryUrlParams();
    this.init()
  },
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.news;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  methods: {
    init() {
      this.$store.commit("showLoading", true);
      this.getdata(this.querys.type)
    },
    getdata(id) {
      this.$ajax.get('/webapi/cmsArticle/getCmsArticleInfo', {
        params: {
          cmsArticleId: id,
        }
      }).then(res => {
        this.$store.commit("showLoading", false);
        this.content = res.data.extraData.cmsArticle.content
        this.title = res.data.extraData.cmsArticle.title
        this.createDates = this.$moment(res.data.extraData.cmsArticle.publishTime).format("YYYY-MM-DD HH:mm:ss")
        this.lastPage = res.data.extraData.lastPage
        this.nextPage = res.data.extraData.nextPage
      })
    },
    clickpage(dd) {
      this.$store.commit("showLoading", true);
      this.$router.push({path: '/cn/detailsProduct', query: {type: dd}});
      this.getdata(dd)
    },
    goProduct() {
      this.$router.push({path: "/cn/activityProduct"})
    }
  },
  watch:{
    '$route':function(to,from){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped lang="scss">
.productInformation {
  background: #f1f1f1;
  width: 100%;
  padding-bottom: 20px;

  .content {
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding-top: 24px;

    p {
      color: #2E2E2E;
      font-size: 14px;
      cursor: pointer;

      &.title {
        border-left: 3px solid #0A57C9;
        padding-left: 13px;
        margin-bottom: 24px;
      }
    }
  }
}

.contmag {
  background: #fff;
  border: 1px solid #ececec;
  width: 100%;
  padding: 0 40px;
}

.footcont {
  border-top: 1px solid #f1f1f1;
  height: 60px;
  margin-top: 10px;

  div {
    width: 50%;
    display: inline-block;
    float: left;
    cursor: pointer;
    padding: 20px 0;
    color: #7c7c7c;
  }

  p {
    color: #666;
  }

  span:hover {
    color: #0A57C9;
  }
}

.contents img {
  display: inline-block !important;
}

.headcont {
  text-align: center;
  border-bottom: 1px solid #f1f1f1;
  line-height: 40px;
  margin-bottom: 15px;

  h2 {
    padding-top: 50px;
    word-wrap: break-word;
  }

  span:hover {
    color: #e2344a;
  }

}

.lastArticle b {
  font-weight: normal;
  width: 375px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: -3px;
  vertical-align: middle;
}

.nextArticle b {
  font-weight: normal;
  width: 420px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: -3px;
  vertical-align: middle;
}
</style>